import { scaleOrdinal as d3scaleOrdinal, ScaleOrdinal as d3ScaleOrdinal } from 'd3';
import { ChartTheme } from './types';

import {
  RedsiftColorPresentationAquaDark,
  RedsiftColorPresentationAquaDarker,
  RedsiftColorPresentationAquaDarkerer,
  RedsiftColorPresentationAquaDefault,
  RedsiftColorPresentationAquaLight,
  RedsiftColorPresentationAquaLighter,
  RedsiftColorPresentationAquaLighterer,
  RedsiftColorPresentationBlueDark,
  RedsiftColorPresentationBlueDarker,
  RedsiftColorPresentationBlueDarkerer,
  RedsiftColorPresentationBlueDefault,
  RedsiftColorPresentationBlueLight,
  RedsiftColorPresentationBlueLighter,
  RedsiftColorPresentationBlueLighterer,
  RedsiftColorPresentationBrownDark,
  RedsiftColorPresentationBrownDarker,
  RedsiftColorPresentationBrownDarkerer,
  RedsiftColorPresentationBrownDefault,
  RedsiftColorPresentationBrownLight,
  RedsiftColorPresentationBrownLighter,
  RedsiftColorPresentationBrownLighterer,
  RedsiftColorPresentationGreenDark,
  RedsiftColorPresentationGreenDarker,
  RedsiftColorPresentationGreenDarkerer,
  RedsiftColorPresentationGreenDefault,
  RedsiftColorPresentationGreenLight,
  RedsiftColorPresentationGreenLighter,
  RedsiftColorPresentationGreenLighterer,
  RedsiftColorPresentationGreyDark,
  RedsiftColorPresentationGreyDarker,
  RedsiftColorPresentationGreyDarkerer,
  RedsiftColorPresentationGreyDefault,
  RedsiftColorPresentationGreyLight,
  RedsiftColorPresentationGreyLighter,
  RedsiftColorPresentationGreyLighterer,
  RedsiftColorPresentationOrangeDark,
  RedsiftColorPresentationOrangeDarker,
  RedsiftColorPresentationOrangeDarkerer,
  RedsiftColorPresentationOrangeDefault,
  RedsiftColorPresentationOrangeLight,
  RedsiftColorPresentationOrangeLighter,
  RedsiftColorPresentationOrangeLighterer,
  RedsiftColorPresentationPinkDark,
  RedsiftColorPresentationPinkDarker,
  RedsiftColorPresentationPinkDarkerer,
  RedsiftColorPresentationPinkDefault,
  RedsiftColorPresentationPinkLight,
  RedsiftColorPresentationPinkLighter,
  RedsiftColorPresentationPinkLighterer,
  RedsiftColorPresentationPurpleDark,
  RedsiftColorPresentationPurpleDarker,
  RedsiftColorPresentationPurpleDarkerer,
  RedsiftColorPresentationPurpleDefault,
  RedsiftColorPresentationPurpleLight,
  RedsiftColorPresentationPurpleLighter,
  RedsiftColorPresentationPurpleLighterer,
  RedsiftColorPresentationRedDark,
  RedsiftColorPresentationRedDarker,
  RedsiftColorPresentationRedDarkerer,
  RedsiftColorPresentationRedDefault,
  RedsiftColorPresentationRedLight,
  RedsiftColorPresentationRedLighter,
  RedsiftColorPresentationRedLighterer,
  RedsiftColorPresentationYellowDark,
  RedsiftColorPresentationYellowDarker,
  RedsiftColorPresentationYellowDarkerer,
  RedsiftColorPresentationYellowDefault,
  RedsiftColorPresentationYellowLight,
  RedsiftColorPresentationYellowLighter,
  RedsiftColorPresentationYellowLighterer,
  Theme,
} from '@redsift/design-system';

export const monochrome = RedsiftColorPresentationBlueDefault;
export const empty = RedsiftColorPresentationGreyDark;

export const scheme = {
  default: [
    RedsiftColorPresentationBlueDefault,
    RedsiftColorPresentationAquaDefault,
    RedsiftColorPresentationPinkDefault,
    RedsiftColorPresentationGreyDefault,
    RedsiftColorPresentationYellowDefault,
    RedsiftColorPresentationPurpleDefault,
    RedsiftColorPresentationGreenDefault,
    RedsiftColorPresentationBrownDefault,
    RedsiftColorPresentationRedDefault,
    RedsiftColorPresentationOrangeDefault,
  ],
  dark: [
    RedsiftColorPresentationGreenDark,
    RedsiftColorPresentationPinkDark,
    RedsiftColorPresentationAquaDark,
    RedsiftColorPresentationBrownDark,
    RedsiftColorPresentationRedDark,
    RedsiftColorPresentationYellowDark,
    RedsiftColorPresentationPurpleDark,
    RedsiftColorPresentationOrangeDark,
    RedsiftColorPresentationBlueDark,
    RedsiftColorPresentationGreyDark,
  ],
  darker: [
    RedsiftColorPresentationGreenDarker,
    RedsiftColorPresentationPinkDarker,
    RedsiftColorPresentationAquaDarker,
    RedsiftColorPresentationBrownDarker,
    RedsiftColorPresentationRedDarker,
    RedsiftColorPresentationYellowDarker,
    RedsiftColorPresentationPurpleDarker,
    RedsiftColorPresentationOrangeDarker,
    RedsiftColorPresentationBlueDarker,
    RedsiftColorPresentationGreyDarker,
  ],
  darkerer: [
    RedsiftColorPresentationGreenDarkerer,
    RedsiftColorPresentationPinkDarkerer,
    RedsiftColorPresentationAquaDarkerer,
    RedsiftColorPresentationBrownDarkerer,
    RedsiftColorPresentationRedDarkerer,
    RedsiftColorPresentationYellowDarkerer,
    RedsiftColorPresentationPurpleDarkerer,
    RedsiftColorPresentationOrangeDarkerer,
    RedsiftColorPresentationBlueDarkerer,
    RedsiftColorPresentationGreyDarkerer,
  ],
  light: [
    RedsiftColorPresentationGreenLight,
    RedsiftColorPresentationPinkLight,
    RedsiftColorPresentationAquaLight,
    RedsiftColorPresentationBrownLight,
    RedsiftColorPresentationRedLight,
    RedsiftColorPresentationYellowLight,
    RedsiftColorPresentationPurpleLight,
    RedsiftColorPresentationOrangeLight,
    RedsiftColorPresentationBlueLight,
    RedsiftColorPresentationGreyLight,
  ],
  lighter: [
    RedsiftColorPresentationGreenLighter,
    RedsiftColorPresentationPinkLighter,
    RedsiftColorPresentationAquaLighter,
    RedsiftColorPresentationBrownLighter,
    RedsiftColorPresentationRedLighter,
    RedsiftColorPresentationYellowLighter,
    RedsiftColorPresentationPurpleLighter,
    RedsiftColorPresentationOrangeLighter,
    RedsiftColorPresentationBlueLighter,
    RedsiftColorPresentationGreyLighter,
  ],
  lighterer: [
    RedsiftColorPresentationGreenLighterer,
    RedsiftColorPresentationPinkLighterer,
    RedsiftColorPresentationAquaLighterer,
    RedsiftColorPresentationBrownLighterer,
    RedsiftColorPresentationRedLighterer,
    RedsiftColorPresentationYellowLighterer,
    RedsiftColorPresentationPurpleLighterer,
    RedsiftColorPresentationOrangeLighterer,
    RedsiftColorPresentationBlueLighterer,
    RedsiftColorPresentationGreyLighterer,
  ],
  monochrome: [monochrome],
  empty: [empty],
};

export const successDangerScheme = {
  success: RedsiftColorPresentationGreenDefault,
  warning: RedsiftColorPresentationOrangeDefault,
  danger: RedsiftColorPresentationRedDefault,
  neutralLight: RedsiftColorPresentationGreyDefault,
  neutralDark: RedsiftColorPresentationGreyDarkerer,
};

export const getColorScale = ({
  colorTheme,
  domain,
  isEmpty,
  theme,
}: {
  colorTheme: ChartTheme;
  domain?: string[];
  isEmpty?: boolean;
  theme: Theme;
}): d3ScaleOrdinal<string, string> => {
  let d3colors = d3scaleOrdinal(scheme.default);

  if (isEmpty) {
    d3colors = d3scaleOrdinal(scheme.empty);
  } else if (typeof colorTheme === 'string') {
    d3colors = d3scaleOrdinal().domain(domain!).range(scheme[colorTheme]).unknown(monochrome) as d3ScaleOrdinal<
      string,
      string
    >;
  } else if (typeof colorTheme === 'object') {
    if (
      Object.keys(colorTheme).includes('success') ||
      Object.keys(colorTheme).includes('danger') ||
      Object.keys(colorTheme).includes('warning')
    ) {
      d3colors = d3scaleOrdinal()
        .domain([
          ...(colorTheme.success ? [colorTheme.success] : []),
          ...(colorTheme.warning ? [colorTheme.warning] : []),
          ...(colorTheme.danger ? [colorTheme.danger] : []),
          ...(colorTheme.neutral ? [colorTheme.neutral] : []),
        ])
        .range([
          ...(colorTheme.success ? [successDangerScheme.success] : []),
          ...(colorTheme.warning ? [successDangerScheme.warning] : []),
          ...(colorTheme.danger ? [successDangerScheme.danger] : []),
          ...(colorTheme.neutral
            ? [theme === Theme.dark ? successDangerScheme.neutralDark : successDangerScheme.neutralLight]
            : []),
        ])
        .unknown(monochrome) as d3ScaleOrdinal<string, string>;
    } else {
      d3colors = d3scaleOrdinal()
        .domain(Object.keys(colorTheme))
        .range(Object.values(colorTheme))
        .unknown(monochrome) as d3ScaleOrdinal<string, string>;
    }
  }

  return d3colors;
};
